import React from 'react';
import { Box } from '@material-ui/core';
import { Typography } from '../../../../../ui-kit';
import { CategoryMarker } from './style';
import { OptionProps } from './types';

const ParentOption = ({ color, name }: OptionProps) => (
    <Box py={1} display='flex' alignItems='center'>
        <CategoryMarker color={color} />
        <Typography fontWeight='bold'>{name}</Typography>
    </Box>
);

export default ParentOption;
